<div class="flex flex-col h-full w-[250px]">
  <div class="flex-1 overflow-y-auto">
    <div class="px-5 mt-5 flex justify-center">
      <img [src]="logo" class="max-h-[100px] object-contain" alt="" />
    </div>
    <div class="mt-5 px-5">
      <p class="text-lg font-semibold" ctrHotelColor>
        {{ title }}
      </p>

      <p class="text-sm">
        {{ subtitle }}
      </p>
    </div>
    <div class="px-2.5">
      <mat-list>
        @for (navItem of navItems; let ind = $index; track ind) {
          <ctr-menu-item [navItem]="navItem"></ctr-menu-item>
        }

        @if (showLogout) {
          <li class="min-h-[35px] my-1.5 rounded-lg overflow-hidden">
            <a
              (click)="logoutClick.emit()"
              routerLinkActive="bg-neutral-200"
              class="flex items-center hover:bg-neutral-200 px-4 py-2.5 rounded-lg cursor-pointer w-full text-gray-600 pl-4"
            >
              <mat-icon fontSet="material-icons-outlined" class="mr-4 w-fit h-fit color-hotel"> input </mat-icon>

              <p class="text-sm">{{ logoutText }}</p>
            </a>
          </li>
        }
      </mat-list>
    </div>
  </div>
  <div class="mx-4 mt-auto pb-6">
    <ng-content></ng-content>
  </div>
</div>
